import { findCenter, distanceBetweenPoints } from '../model/DataTransformation';

//Possibly no longer needed
const distanceMapListToObject = (list) => {
    return list.reduce((dmap, row) => {
        let { pointA, pointB, DIST } = row;
        if (!(pointA in dmap)) dmap[pointA] = {};
        dmap[pointA][pointB] = DIST;
        return dmap;
    }, {});
};
export { distanceMapListToObject };

const getAllIdsFromDistanceMap = (data) => {
    return data.reduce((ids, p) => {
        ids.add(p.pointA);
        ids.add(p.pointB);
        return ids;
    }, new Set());
};
export { getAllIdsFromDistanceMap };

//ΔVΔVΔ: Transform distance map to an object of ids with the best matching distances
const optimizeDistanceMap = (dmap) => {
    var range = Infinity;
    var rowsInRange = dmap.filter((p) => p.DIST <= range);

    var ordered = rowsInRange.sort((a, b) => {
        return a.DIST - b.DIST;
    });

    let row = ordered.pop();
    let addSet = new Set();
    let distObj = {};
    while (row) {
        let { pointA, pointB, DIST } = row;
        if (!(pointA in distObj)) distObj[pointA] = {};
        distObj[pointA][pointB] = DIST;
        addSet.add(pointA);
        addSet.add(pointB);
        ordered = ordered.filter((r) => {
            return r.pointA != pointB && r.pointB != pointB;
        });
        row = ordered.pop();
    }
    return distObj;
};
export { optimizeDistanceMap };

//ΔVΔVΔ: Transform a list of pois with the attributes: (ID,x,y) to a distance map with schema: {pointA,pointB,DIST}
const createBasicDistanceMap = (poilist) => {
    var dmap = [];
    for (var i = 0; i < poilist.length; i++) {
        var pointA = poilist[i].ID;
        var pointACoords = [poilist[i].x, poilist[i].y];
        for (var j = i + 1; j < poilist.length; j++) {
            var pointB = poilist[j].ID;
            var pointBCoords = [poilist[j].x, poilist[j].y];
            var DIST = distanceBetweenPoints(pointACoords, pointBCoords);
            dmap.push({ pointA, pointB, DIST });
        }
    }
    return dmap;
};
export { createBasicDistanceMap };

const createDistanceMap = (poilist, range = 1e11) => {
    var dmap = [];
    console.time('count');
    for (var i = 0; i < poilist.length; i++) {
        var k = i % 1000;
        if (k == 0) {
            console.log(i);
            console.timeLog('count');
        }
        var pointA = poilist[i].ID;
        var pointACoords = [poilist[i].x, poilist[i].y];
        for (var j = i + 1; j < poilist.length; j++) {
            var pointB = poilist[j].ID;
            var pointBCoords = [poilist[j].x, poilist[j].y];
            var DIST = distanceBetweenPoints(pointACoords, pointBCoords);
            if (DIST < range) dmap.push({ pointA, pointB, DIST });
        }
    }
    return dmap;
};
export { createDistanceMap };

const minMaxDistFromMap = (list, minimum = 1000, cap = 0, key = 'DIST') => {
    //return ,min,max,count
    return list.reduce(
        (out, line) => {
            let d = line[key];
            if (cap && d > cap) return out;
            if (d < minimum) return out;
            return [Math.min(out[0], d), Math.max(out[1], d), out[2] + 1];
        },
        [Infinity, 0, 0]
    );
};
export { minMaxDistFromMap };

// ΔVΔVΔ: Use to filter out tile data by individual POI
// ΔVΔVΔ: Helper function for testing
const reduceTileLookupData = (tileData, mapFn = () => {}) => {
    return tileData.reduce((outputTileArr, tile) => {
        const reducedList = tile.list.reduce((outputPoiList, poi) => {
            const newPOI = mapFn && poi && mapFn(poi);
            if (newPOI) outputPoiList.push(newPOI);
            return outputPoiList;
        }, []);

        if (reducedList.length) outputTileArr.push({ count: reducedList.length, key: tile.key, list: reducedList });
        return outputTileArr;
    }, []);
};
export { reduceTileLookupData };

const pointDensityMap = (list, range, muliplier = 1) => {
    // list = {pointA,pointB,DIST}
    var ids = new Set();
    var chart = [];
    // const linesInRange = distances.filter((ln) => ln.DIST < d);
    for (var item of list) {
        const point = item.pointA;
        if (!ids.has(point)) {
            ids.add(point);
            const lines = list.filter((line) => line.DIST < range && line.pointA === point);
            const mass = lines.length;
            const totalDistance = lines.reduce((val, line) => {
                return (val += line.DIST);
            }, 0);
            const averageDistance = totalDistance / mass;
            const volume = averageDistance;
            //volume is actually the range (or max range)
            let density = (mass / volume) * muliplier;
            density = density == Infinity ? 0 : density;
            chart.push({ point: point, mass, density, volume, lines });
        }
    }
    return chart.sort((a, b) => b.mass - a.mass);
    // return chart.sort((a, b) => b.density - a.density);
    // return chart.sort((a, b) => b.mass + b.density - a.mass + a.density);
};
export { pointDensityMap };

const pointDensityMap2 = (list, range) => {
    // list = {pointA,pointB,DIST}
    var ids = new Set();
    var chart = [];
    var orderedListInRange = list.filter((ln) => ln.DIST < range).sort((a, b) => a.DIST - b.DIST);
    for (var item of list) {
        const point = item.pointA;
        if (!ids.has(point)) {
            ids.add(point);
            // console.log(point, point == '1222318878');
            let dd = point == '1222318878';

            const lines = orderedListInRange.filter((line) => line.DIST < range && line.pointA === point);
            const mass = Math.max(lines.length, 1);
            const totalDistance = lines.reduce((val, line) => {
                return (val += line.DIST);
            }, 0);
            // if (!lines.length) {
            //     console.log(
            //         'lines length:',
            //         lines.length,
            //         'basicLines =>',
            //         list.filter((line) => line.pointA === point)
            //     );
            // }
            const volume = totalDistance / mass; //volume is average distance
            // console.log('ms', mass, 'aveD', Math.floor(volume), 'total D', totalDistance, 'av is larger?', volume > totalDistance);a
            dd && console.table({ lines, mass, totalDistance, volume });

            chart.push({ point: point, mass, volume, lines });
        }
    }
    var total_mass = chart.length;
    const calculateG = (ln) => {
        var massPer = (ln.mass / total_mass) * 300;
        var density = ((range - ln.volume) / range) * 10;
        return density + massPer;
    };
    chart = chart.map((ln) => {
        ln.g = calculateG(ln);
        return ln;
    });

    return chart.sort((a, b) => b.g - a.g);
    // return chart.sort((a, b) => b.mass - a.mass);
};

export { pointDensityMap2 };

const clusterMapByDensity = (dmap) => {
    var allocatedIDs = new Set();
    var clusters = [];
    for (var line of dmap) {
        const { point, lines } = line;
        if (!allocatedIDs.has(point)) {
            allocatedIDs.add(point);
            var unusedLines = lines.filter((ln) => !allocatedIDs.has(ln.pointB)).map((ln) => ln.pointB);
            var data = [point];
            for (var pt of unusedLines) {
                allocatedIDs.add(pt);
                data.push(pt);
            }
            clusters.push({ point, data });
        }
    }
    return clusters;
};
export { clusterMapByDensity };

const clusterMapByDensityAndRange = (dmap, range) => {
    var allocatedIDs = new Set();
    var clusters = [];
    for (var line of dmap) {
        const { point, lines } = line;
        if (!allocatedIDs.has(point)) {
            allocatedIDs.add(point);
            var unusedLines = lines.filter((ln) => !allocatedIDs.has(ln.pointB) && ln.DIST < range).map((ln) => ln.pointB);
            if (lines.length) {
                console.log('Total lines', lines);
                const linesInRange = lines.filter((ln) => ln.DIST < range).map((ln) => ln.pointB);
                console.log('in range: ', range, linesInRange);
                console.log(unusedLines);
            }
            var data = [point];
            for (var pt of unusedLines) {
                allocatedIDs.add(pt);
                data.push(pt);
            }
            clusters.push({ point, data });
        }
    }
    return clusters;
};
export { clusterMapByDensityAndRange };

const bubbleMapByDistance = (distance, densityMap) => {
    var allocatedIDs = new Set();
    for (var row of densityMap) {
        const { point, lines } = row;
        if (!allocatedIDs.has(point)) {
            allocatedIDs.add(point);
            const linesInRange = lines.filter((ln) => {
                return ln.DIST < distance && !allocatedIDs.has(ln.pointB);
            });
            for (var ln in linesInRange) {
                allocatedIDs.add(ln.pointB);
            }
        }
    }
};

const getCoordsFromList = (list) => list.map((poi) => [poi.x, poi.y]);
export { getCoordsFromList };

const findCenterOfList = (list) => {
    return findCenter(getCoordsFromList(list));
};
export { findCenterOfList };

const findCenterPixelFromList = (list, map) => {
    const center = findCenterOfList(list);
    return map.getPixelFromCoordinate(center).map((i) => Math.floor(i));
};
export { findCenterPixelFromList };
